<template>
  <v-card
    flat
    class="mt-5"
  >
    <v-form>
      <div class="px-3">
        <v-card-title class="flex-nowrap">
          <span class="text-break">Reset Password</span>
        </v-card-title>
        <v-card-text class="pt-5">
          <div class="wrapper-reset-password">
            <v-row v-if="loadingPassword">
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="primary"
                  indeterminate
                  class="d-block ma-auto mt-5"
                ></v-progress-circular>
              </v-col>
            </v-row>

            <v-row v-if="!loadingPassword">
              <v-col
                v-if="resetPassword"
                cols="12"
                sm="12"
                md="12"
              >
                <div>
                  <v-text-field
                    v-model="validationCode"
                    type="text"
                    label="Validation Code"
                    outlined
                    dense
                    @click:append="isCurrentPasswordVisible = !isCurrentPasswordVisible"
                  ></v-text-field>

                  <v-text-field
                    v-model="newPassword"
                    :type="isNewPasswordVisible ? 'text' : 'password'"
                    :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                    label="New Password"
                    outlined
                    dense
                    hint="Make sure it's at least 8 characters."
                    persistent-hint
                    @click:append="isNewPasswordVisible = !isNewPasswordVisible"
                  ></v-text-field>
                </div>

                <p
                  v-if="loadingPassword"
                  class="mt-5 text-sm text--primary text-center"
                >
                  Updating password...
                </p>

                <v-btn
                  color="primary"
                  class="d-block ma-auto mt-5"
                  @click="sendVCode()"
                >
                  Update password
                </v-btn>
              </v-col>

              <v-col
                v-if="!resetPassword"
                cols="12"
                sm="12"
                md="12"
                class="d-block justify-center position-relative"
              >
                <p class="text-base font-weight-semibold text--primary text-center">
                  You'll receive an email with a validation code to reset your password.
                </p>
                <v-btn
                  color="primary"
                  class="d-block ma-auto"
                  @click="sendVCode()"
                >
                  Send the Code
                </v-btn>

                <v-alert
                  v-if="message.status === 0"
                  dense
                  outlined
                  type="error"
                  class="mt-5"
                >
                  {{ message.text }}
                </v-alert>
                <v-alert
                  v-if="message.status === 1"
                  dense
                  text
                  type="success"
                  class="mt-5"
                >
                  {{ message.text }}
                </v-alert>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>

      <v-divider></v-divider>

      <div class="pa-3">
        <v-card-title class="flex-nowrap">
          <span class="text-break">Account Privacy</span>
        </v-card-title>

        <v-card-text class="two-factor-auth text-center mx-auto">
          <v-avatar
            color="primary"
            class="primary mb-4"
            rounded
          >
            <v-icon
              size="25"
              color="white"
            >
              {{ userPrivacy ? icons.mdiEye : icons.mdiEyeOff }}
            </v-icon>
          </v-avatar>
          <div class="wrapper-content">
            <template v-if="!loading">
              <p class="text-base text--primary font-weight-semibold switch-profile">
                Your profile is {{ userPrivacy ? 'Public' : 'not Public' }}.
              </p>
              <v-switch
                v-model="userPrivacy"
                inset
                :disabled="loading"
                class="switch-content-type text-center mx-auto"
                @change="updatePrivacy"
              ></v-switch>
              <p class="text-sm text--primary">
                {{ userPrivacy ? 'Check your categories and files if you want to hide something specific.' : 'This action hides your public profile and will only affect the `/user/username` share link.' }}
              </p>

              <v-alert
                v-if="privacyMessage.status === 0"
                dense
                outlined
                type="error"
                class="mt-4"
              >
                {{ privacyMessage.text }}
              </v-alert>

              <v-alert
                v-if="privacyMessage.status === 1"
                dense
                text
                type="success"
                class="mt-4"
              >
                {{ privacyMessage.text }}
              </v-alert>
            </template>
            <v-progress-linear
              v-if="loading"
              color="primary accent-4 loader"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
        </v-card-text>
      </div>
      <v-divider></v-divider>

      <div class="pa-3">
        <v-card-title class="flex-nowrap">
          <span class="text-break">Like Notifications</span>
        </v-card-title>

        <v-card-text class="two-factor-auth text-center mx-auto">
          <v-avatar
            color="primary"
            class="primary mb-4"
            rounded
          >
            <v-icon
              size="25"
              color="white"
            >
              {{ likeNotifications ? icons.mdiHeart : icons.mdiHeartOff }}
            </v-icon>
          </v-avatar>
          <div class="wrapper-content">
            <template v-if="!likeNotifLoading">
              <p class="text-base text--primary font-weight-semibold switch-profile">
                Like notifications are {{ likeNotifications ? 'enabled' : 'disabled' }}.
              </p>
              <v-switch
                v-model="likeNotifications"
                inset
                :disabled="likeNotifLoading"
                class="switch-content-type text-center mx-auto"
                @change="updateLikeNotifications"
              ></v-switch>
              <p class="text-sm text--primary">
                {{ likeNotifications ? 'You will receive notifications when someone likes your content.' : 'You will not receive like notifications.' }}
              </p>

              <v-alert
                v-if="likeNotifMessage.status === 0"
                dense
                outlined
                type="error"
                class="mt-4"
              >
                {{ likeNotifMessage.text }}
              </v-alert>

              <v-alert
                v-if="likeNotifMessage.status === 1"
                dense
                text
                type="success"
                class="mt-4"
              >
                {{ likeNotifMessage.text }}
              </v-alert>
            </template>
            <v-progress-linear
              v-if="likeNotifLoading"
              color="primary accent-4 loader"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
        </v-card-text>
      </div>
      <v-divider></v-divider>

      <div class="pa-3">
        <v-card-title class="flex-nowrap">
          <span class="text-break">Comment Notifications</span>
        </v-card-title>

        <v-card-text class="two-factor-auth text-center mx-auto">
          <v-avatar
            color="primary"
            class="primary mb-4"
            rounded
          >
            <v-icon
              size="25"
              color="white"
            >
              {{ commentNotifications ? icons.mdiComment : icons.mdiCommentOff }}
            </v-icon>
          </v-avatar>
          <div class="wrapper-content">
            <template v-if="!commentNotifLoading">
              <p class="text-base text--primary font-weight-semibold switch-profile">
                Comment notifications are {{ commentNotifications ? 'enabled' : 'disabled' }}.
              </p>
              <v-switch
                v-model="commentNotifications"
                inset
                :disabled="commentNotifLoading"
                class="switch-content-type text-center mx-auto"
                @change="updateCommentNotifications"
              ></v-switch>
              <p class="text-sm text--primary">
                {{ commentNotifications ? 'You will receive notifications when someone comments on your content.' : 'You will not receive comment notifications.' }}
              </p>

              <v-alert
                v-if="commentNotifMessage.status === 0"
                dense
                outlined
                type="error"
                class="mt-4"
              >
                {{ commentNotifMessage.text }}
              </v-alert>

              <v-alert
                v-if="commentNotifMessage.status === 1"
                dense
                text
                type="success"
                class="mt-4"
              >
                {{ commentNotifMessage.text }}
              </v-alert>
            </template>
            <v-progress-linear
              v-if="commentNotifLoading"
              color="primary accent-4 loader"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
        </v-card-text>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios'
import {
  mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline, mdiEye, mdiEyeOff, mdiHeart, mdiHeartOff,
  mdiComment, mdiCommentOff,
} from '@mdi/js'

export default {
  data() {
    return {
      icons: {
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
        mdiEye,
        mdiEyeOff,
        mdiHeart,
        mdiHeartOff,
        mdiComment,
        mdiCommentOff,
      },
      resetPassword: false,
      isNewPasswordVisible: false,
      validationCode: '',
      newPassword: '',
      userPrivacy: !!parseInt(localStorage.getItem('is_public'), 10),
      initializedPrivacy: false,
      endpoint: process.env.VUE_APP_ROOT_API,
      active: true,
      logged: true,
      loading: false,
      loadingPassword: false,
      privacyMessage: {
        status: null,
        text: null,
      },
      likeNotifications: true,
      likeNotifLoading: false,
      likeNotifMessage: {
        status: null,
        text: null,
      },
      commentNotifications: true,
      commentNotifLoading: false,
      commentNotifMessage: {
        status: null,
        text: null,
      },
      message: {
        status: null,
        text: null,
      },
    }
  },
  mounted() {
    if (this.$store.state.user && this.$store.state.user.extra_data) {
      const dbPublic = this.$store.state.user.extra_data.public
      if (dbPublic !== undefined && dbPublic !== null) {
        this.userPrivacy = !!parseInt(dbPublic, 10)
        localStorage.setItem('is_public', this.userPrivacy ? '1' : '0')
      }

      const dbLikeNotif = this.$store.state.user.extra_data.like_notifications
      if (dbLikeNotif !== undefined && dbLikeNotif !== null) {
        this.likeNotifications = !!parseInt(dbLikeNotif, 10)
      }

      const dbCommentNotif = this.$store.state.user.extra_data.comment_notifications
      if (dbCommentNotif !== undefined && dbCommentNotif !== null) {
        this.commentNotifications = !!parseInt(dbCommentNotif, 10)
      }
    }

    this.initializedPrivacy = true
  },
  methods: {
    checkLogin() {
      this.$store.commit('setLogin', true)
      this.active = true
      this.logged = true
      this.searchCategory(-1, 1)
    },
    sendVCode() {
      this.loadingPassword = true
      axios.post(`${this.endpoint}/resetPassword`, {
        requestCode: this.resetPassword,
        newPassword: this.newPassword,
        validationCode: this.validationCode,
      }, {
        headers: {
          Authorization: this.$store.state.jwtToken,
        },
      }).then(responseDB => {
        this.loadingPassword = false
        this.message.status = null
        if (Object.keys(responseDB.data.result).length) {
          if (responseDB.data.result.hasOwnProperty('CodeDeliveryDetails')) {
            console.log('Email sent')
            this.resetPassword = true
          } else {
            this.resetPassword = false
            this.message = {
              status: 0,
              text: responseDB.data.result.message,
            }
          }
        } else {
          this.resetPassword = false
          this.message = {
            status: 1,
            text: 'The password has been updated.',
          }

          setTimeout(() => {
            this.message.status = null
          }, 6000)
        }
      }).catch(() => {
        this.loadingPassword = false
        this.message = {
          status: 0,
          text: 'Could not update your password right now.',
        }
      })
    },
    async updatePrivacy(value) {
      if (!this.initializedPrivacy) {
        return
      }

      if (!this.endpoint) {
        this.privacyMessage = {
          status: 0,
          text: 'Missing API endpoint configuration (VUE_APP_ROOT_API).',
        }

        return
      }

      const nextValue = typeof value === 'boolean' ? value : this.userPrivacy
      const previousValue = !nextValue

      this.loading = true
      this.privacyMessage.status = null

      try {
        await axios.post(`${this.endpoint}/updateUserData`, {
          public: nextValue ? 1 : 0,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })

        localStorage.setItem('is_public', nextValue ? '1' : '0')
        this.$store.commit('setPublic', nextValue ? 1 : 0)

        const currentUser = this.$store.state.user || { extra_data: {} }
        this.$store.commit('setUser', {
          ...currentUser,
          extra_data: {
            ...currentUser.extra_data,
            public: nextValue ? 1 : 0,
          },
        })

        this.privacyMessage = {
          status: 1,
          text: `Profile privacy updated to ${nextValue ? 'Public' : 'Private'}.`,
        }
      } catch (error) {
        const backendMessage = error && error.response && error.response.data && error.response.data.message
        this.userPrivacy = previousValue
        this.privacyMessage = {
          status: 0,
          text: backendMessage || 'Could not save privacy settings right now.',
        }
      } finally {
        this.loading = false
      }
    },
    async updateLikeNotifications(value) {
      const nextValue = typeof value === 'boolean' ? value : this.likeNotifications
      const previousValue = !nextValue

      this.likeNotifLoading = true
      this.likeNotifMessage.status = null

      try {
        await axios.post(`${this.endpoint}/updateUserData`, {
          like_notifications: nextValue ? 1 : 0,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })

        const currentUser = this.$store.state.user || { extra_data: {} }
        this.$store.commit('setUser', {
          ...currentUser,
          extra_data: {
            ...currentUser.extra_data,
            like_notifications: nextValue ? 1 : 0,
          },
        })

        this.likeNotifMessage = {
          status: 1,
          text: `Like notifications ${nextValue ? 'enabled' : 'disabled'}.`,
        }
      } catch (error) {
        const backendMessage = error && error.response && error.response.data && error.response.data.message
        this.likeNotifications = previousValue
        this.likeNotifMessage = {
          status: 0,
          text: backendMessage || 'Could not update like notification settings right now.',
        }
      } finally {
        this.likeNotifLoading = false
      }
    },
    async updateCommentNotifications(value) {
      const nextValue = typeof value === 'boolean' ? value : this.commentNotifications
      const previousValue = !nextValue

      this.commentNotifLoading = true
      this.commentNotifMessage.status = null

      try {
        await axios.post(`${this.endpoint}/updateUserData`, {
          comment_notifications: nextValue ? 1 : 0,
        }, {
          headers: {
            Authorization: this.$store.state.jwtToken,
          },
        })

        const currentUser = this.$store.state.user || { extra_data: {} }
        this.$store.commit('setUser', {
          ...currentUser,
          extra_data: {
            ...currentUser.extra_data,
            comment_notifications: nextValue ? 1 : 0,
          },
        })

        this.commentNotifMessage = {
          status: 1,
          text: `Comment notifications ${nextValue ? 'enabled' : 'disabled'}.`,
        }
      } catch (error) {
        const backendMessage = error && error.response && error.response.data && error.response.data.message
        this.commentNotifications = previousValue
        this.commentNotifMessage = {
          status: 0,
          text: backendMessage || 'Could not update comment notification settings right now.',
        }
      } finally {
        this.commentNotifLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.two-factor-auth {
  max-width: 25rem;
}
.security-character {
  position: absolute;
  bottom: -0.5rem;
}

.switch-content-type {
  width: 44px;
}

.loader, .switch-content-type {
  margin: 20px auto 5px;
}
.wrapper-content {
  min-height: 140px;
}

.v-progress-linear {
  top: 50px;
}

.wrapper-reset-password {
  max-width: 500px;
  margin: 0 auto;
}
</style>
